import React from 'react'
import styled from 'styled-components'

const horisontals = {
  left: 'left: 0',
  middle: 'left: 55%; transform: translateX(-50%)',
  right: 'right: 0',
}

const verticals = {
  top: 'top: 0',
  middle: 'top: 50%; transform: translateY(-50%)',
  bottom: 'bottom: 0',
}

const Button = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  font-weight: 700;
  ${({ positions }) => horisontals[positions.x] || 'left: 0'};
  ${({ positions }) => verticals[positions.y] || 'top: 0'};
  color: ${props => props.isOpen ? '#ffffff' : '#00B0B9'};
  padding: 14px;
  cursor: pointer;
  z-index: 300;
  @media screen and (min-width: 768px) {
    padding: 10px 14px;
    color: ${props => props.isOpen ? '#ffffff' : '#0D1C42'};
  }
  ${props => props};
  a {
    color: #0D1C42;
  }
`

const ArrowHolder = styled.div`
  display: inline-block;
  transition: transform .3s;
  ${props => props.isOpen && 'transform: rotate(180deg);'}
  width: 17px;
  height: 17px;

  svg {
    height: 100%;
    width: 100%;
  }
`

const TextView = styled.span`
  margin-right: 22px;
  display: inline-flex;
  vertical-align: middle;
  font-size: 0.75rem;
  font-family: 'Sica', sans-serif;

  @media screen and (min-width: 768px) {
    font-size: 1.1875rem;
    font-weight: 400;
  }
`

const Arrow = ({ isOpen }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14.981" height="14.981" viewBox="0 0 14.981 14.981">
    <g transform="translate(-1263.186 -14.5)">
      <path id="Path_986" data-name="Path 986" d="M390-215h14.127v14.127" transform="translate(873.539 230)" fill="none" stroke={`${isOpen ? '#ffffff' : '#0d1c42'}`} strokeMiterlimit="10" strokeWidth="1"/>
      <line id="Line_12" data-name="Line 12" x1="13.833" y2="13.833" transform="translate(1263.539 15.295)" fill="none" stroke={`${isOpen ? '#ffffff' : '#0d1c42'}`} strokeMiterlimit="10" strokeWidth="1"/>
    </g>
  </svg>
)

const MenuButton = ({ text, children, onClickHandler, positions, isOpen, ...rest }) => (
  <Button isOpen={isOpen} positions={positions} onClick={onClickHandler} {...rest}>
    <TextView>{children ? children : isOpen ? 'CLOSE' : text}</TextView>
    <ArrowHolder isOpen={isOpen}>
      <Arrow isOpen={isOpen}/>
    </ArrowHolder>
  </Button>
)

export default MenuButton